import React from "react";
import "../style/medicine.css";
import Servicessidebar from "../components/servicessidebar";


const points = [
    {
        icon: "➤",
        text: "Expert medical consultation in routine and emergency hours"
    },
    {
        icon: "✔",
        text: "Medical ICU care beds with all invasive and non-invasive monitoring and support systems"
    },
    {
        icon: "➤",
        text: "System of co-ordination amongst all medical departments for special care of Infectious Diseases"
    },
    {
        icon: "✔",
        text: "Regular community Health Camps, continuous medical education programs and disease preventive clinics"
    }
];

const Medicine = () => {
    return (
        <div className="internal-section">
            <div className="container">
                <div className="medicine-je">
                    <div className="internal-jp">
                        <h2 className="internal-title">INTERNAL MEDICINE</h2>

                        <p className="internal-description">
                            Internal Medicine is the backbone of any multi-speciality hospital. Since inception,
                            SAL Hospital has recognized its pivotal role and created a holistic wing led by skilled
                            physicians/consultants with over three decades of clinical & educational experience,
                            who cater to all types of common and rare medical ailments.
                        </p>

                        <ul className="internal-list">
                            {points.map((item, index) => (
                                <li key={index} className="internal-item">
                                    <span className="internal-icon">{item.icon}</span>
                                    {item.text}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="medicine-side">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Medicine;
